/**
 * Phase 20.3: Hook to read the active workspace's display currency.
 *
 * Returns the ISO 4217 code from the active organization, or 'USD' as a
 * sensible fallback (used in localStorage mode and during the brief window
 * before the workspace record loads).
 *
 * Components that display monetary values pair this with formatCurrency:
 *   const currency = useWorkspaceCurrency();
 *   return formatCurrency(amount, { currency });
 *
 * The hook subscribes to the activeOrg slice via Zustand's normal selector,
 * so changes (workspace switch, currency setting change) trigger re-render
 * automatically.
 */

import { useProjectStore } from '@/store/useProjectStore';

export function useWorkspaceCurrency(): string {
  return useProjectStore((s) => s.activeOrg?.currency ?? 'USD');
}
